import api from './api';

export interface User {
  id: number;
  name: string;
  email: string;
  role: 'admin' | 'coordinator';
  center: string;
  staff_status: 'active' | 'inactive';
  last_login_at: string | null;
}

export const userService = {
  async list(params?: { role?: string; status?: string }) {
    const { data } = await api.get<{ data: User[] }>('/users', { params });
    return data.data;
  },

  async get(id: number) {
    const { data } = await api.get<User>(`/users/${id}`);
    return data;
  },

  async create(payload: { name: string; email: string; password: string; role: string; center?: string }) {
    const { data } = await api.post<User>('/users', payload);
    return data;
  },

  async update(id: number, payload: Partial<User & { password?: string }>) {
    const { data } = await api.put<User>(`/users/${id}`, payload);
    return data;
  },

  async delete(id: number) {
    await api.delete(`/users/${id}`);
  },

  async toggleStatus(id: number) {
    const { data } = await api.patch<User>(`/users/${id}/toggle-status`);
    return data;
  },
};
